import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BACKBONE_URL } from '../../shared/constants';
import { AuthService } from '../http-services/auth.service';
import { AzureTokenService } from '../services/azure-token.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,
    private azureTokenSerivce: AzureTokenService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const isLoggedIn = this.authService.isLoggedIn();
    const isApiUrl = request.url.startsWith(BACKBONE_URL);
    const isAzureApiUrl = request.url.includes('azure.com');
    if (isLoggedIn && isApiUrl) {
      const user = this.authService.userValue;
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user.AuthenticationToken}`
        }
      });
    }
    else if (isAzureApiUrl && this.azureTokenSerivce.isLoggedIn()) {
      //MICROSOFT'S AZURE CALL, MUST ENTER TOKEN OBTAINED VIA MSAL
      var token = this.azureTokenSerivce.retrieveToken().accessToken;
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request);
  }
}
